<template>
  <div>
    <div class="row justify-content-md-center" v-cloak v-if="!state.loaded">
      <div class="col col-lg-2"></div>
      <div class="col-md-auto mt-20">
        <rotate-square5></rotate-square5>
      </div>
      <div class="col col-lg-2"></div>
    </div>
    <div class="card card-body printableArea" v-else>
      <h3>
        <b>Detail</b>
        <span class="pull-right">
          <button
            type="button"
            @click="goBack()"
            class="btn btn-inverse"
            title="Kembali"
          >
            Kembali
          </button>
        </span>
      </h3>
      <hr />
      <div class="row">
        <div class="col-md-12 justify-content-md-center">
          <div class="col-md-6 pull-left">
            <small class="text-muted">Tipe</small>
            <h6>
              {{
                state.detail.type_doc !== undefined &&
                state.detail.type_doc !== null &&
                state.detail.type_doc !== ""
                  ? state.detail.type_doc.text
                  : "-"
              }}
            </h6>
            <small class="text-muted">Nama</small>
            <h6>{{ state.detail.name }}</h6>
            <small class="text-muted">Induk</small>
            <h6>
              {{
                state.detail.parent !== undefined &&
                state.detail.parent !== null &&
                state.detail.parent !== "" && 
                state.detail.parent.length > 0 
                  ? state.detail.parent.text
                  : "-"
              }}
            </h6>
            <small class="text-muted">Kode</small>
            <h6>
              {{
                state.detail.kode !== undefined &&
                state.detail.kode !== null &&
                state.detail.kode !== ""
                  ? state.detail.kode
                  : "-"
              }}
            </h6>
            <small class="text-muted">Tipe Unit</small>
            <h6>
              {{
                state.detail.type_text !== undefined &&
                state.detail.type_text !== null &&
                state.detail.type_text !== ""
                  ? state.detail.type_text
                  : "-"
              }}
            </h6>
            
            <small class="text-muted">Akronim</small>
            <h6>
              {{
                state.detail.akronim !== undefined &&
                state.detail.akronim !== null &&
                state.detail.akronim !== ""
                  ? state.detail.akronim
                  : "-"
              }}
            </h6>
            <!-- <small class="text-muted">Eselon</small>
            <h6>{{(state.detail.eselon!==undefined && state.detail.eselon!==null && state.detail.eselon!=='')?state.detail.eselon:'-'}}</h6>
            <small class="text-muted">OPD/Pokja</small>
            <h6>{{(state.detail.type!==undefined && state.detail.type!==null && state.detail.type!=='')?(state.detail.type==1?'OPD / UNIT KERJA':'POKJA / Subunit'):'-'}}</h6> -->
            <!-- <small class="text-muted p-t-30 db">Submitted</small>
            <h6>{{submitted}}</h6>
            <small class="text-muted p-t-30 db">Modified</small>
            <h6>{{modified}}</h6> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RotateSquare5 } from "vue-loading-spinner";
import ImageItem from "@/components/img/imgItem";
export default {
  components: {
    RotateSquare5,
    ImageItem,
  },
  computed: {
    base() {
      return this.baseUrl;
    },
    state() {
      return this.$store.state.unit;
    },
    submitted() {
      return this.formatDate(this.state.detail.created_at);
    },
    modified() {
      return this.formatDate(this.state.detail.updated_at);
    },
  },
  mounted() {
    this.detailLoad();
    let that = this
    setTimeout(function(){
      console.log(JSON.stringify(that.state.detail))
    }, 2000)
  },
  methods: {
    detailLoad() {
      const state = {
        loaded: false,
      };
      this.$store.commit("unit/STATE", state);
      this.$store.dispatch("unit/getUnitsById", this.$route.params);
    },
    goBack() {
      this.$store.dispatch("unit/onCancel");
    },
  },
};
</script>
